import React from "react";
import { X } from "lucide-react";
import { buildWaLink } from "../lib/api";

// Poster harga sewa kendaraan
const POSTER = "/services/car-rental.png";

// Nomor WhatsApp Malaysia
const WA_MY = "60182862358";

const TEXT = {
  id: {
    title: "Sewa Kendaraan",
    sub: "Cek harga di bawah, lalu hubungi kami via WhatsApp",
    msg: "Halo CEO Travel 👋, saya mau tanya sewa kendaraan di Batam. Boleh info harga & ketersediaan?",
  },
  en: {
    title: "Car Rental",
    sub: "Check the rates below, then contact us on WhatsApp",
    msg: "Hello CEO Travel 👋, I'd like to ask about car rental in Batam. Could you share the rates & availability?",
  },
  zh: {
    title: "汽车租赁",
    sub: "查看以下价格，然后通过 WhatsApp 联系我们",
    msg: "您好 CEO Travel 👋，我想咨询巴淡岛汽车租赁，请问价格与可预订情况？",
  },
};

export const TransportModal = ({ open, onClose, lang = "id" }) => {
  if (!open) return null;

  const t = TEXT[lang] || TEXT.id;

  const openWa = (phone) => {
    const url = phone
      ? `https://wa.me/${phone}?text=${encodeURIComponent(t.msg)}`
      : buildWaLink(t.msg);
    window.open(url, "_blank");
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0C2230]/70 p-4 backdrop-blur-sm"
      onClick={onClose}
      data-testid="transport-modal"
    >
      <div
        className="relative flex max-h-[92vh] w-full max-w-md flex-col overflow-hidden rounded-3xl bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-start justify-between border-b border-[#0C2230]/8 px-6 py-5">
          <div>
            <h3 className="font-[Fraunces] text-xl font-medium text-[#0C2230]">
              {t.title}
            </h3>
            <p className="mt-0.5 text-xs text-[#0C2230]/60">{t.sub}</p>
          </div>
          <button
            onClick={onClose}
            aria-label="Tutup"
            className="rounded-full p-1 text-[#0C2230]/50 transition hover:bg-[#0C2230]/5 hover:text-[#0C2230]"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Poster (scrollable) */}
        <div className="flex-1 overflow-y-auto px-4 py-4">
          <img
            src={POSTER}
            alt={t.title}
            className="w-full rounded-2xl ring-1 ring-[#0C2230]/10"
          />
        </div>

        {/* Tombol WhatsApp */}
        <div className="border-t border-[#0C2230]/8 p-4">
          <div className="grid grid-cols-2 gap-3">
            <button
              onClick={() => openWa(null)}
              data-testid="transport-wa-id"
              className="flex items-center justify-center gap-2 rounded-xl bg-[#25D366] px-4 py-3 text-sm font-bold text-white shadow-md transition hover:bg-[#20bd5a]"
            >
              🇮🇩 WhatsApp
            </button>
            <button
              onClick={() => openWa(WA_MY)}
              data-testid="transport-wa-my"
              className="flex items-center justify-center gap-2 rounded-xl bg-[#25D366] px-4 py-3 text-sm font-bold text-white shadow-md transition hover:bg-[#20bd5a]"
            >
              🇲🇾 WhatsApp
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransportModal;
